<template>
  <v-container>
    <v-row justify="space-between" align="center" class="mb-6">
      <v-col cols="12" md="5">
        <h2>Student Image Matching</h2>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-end align-center" style="gap: 8px;">
        <v-btn color="primary" @click="showDialog = true">Instructions</v-btn>
        <!-- <v-btn color="success" :to="{ name: 'uploadImages' }">Upload Images (Roll ID)</v-btn> -->
      </v-col>
    </v-row>

    <!-- Form Controls -->
    <v-row>
      <v-col cols="12" md="4">
        <v-select v-model="userType" :items="userTypes" label="Select User Type" outlined dense />
      </v-col>
      <v-col cols="12" md="4" v-if="userType === 'Student'">
      <!-- <v-col cols="12" md="3"> -->
        <v-select v-model="selectedClass" :items="classStore.getClassDropdownItems" item-title="title"
          item-value="value" label="Select Class" outlined dense @update:modelValue="fetchStudents" />
      </v-col>

      <v-col cols="12" md="3">
        <!-- <v-file-input v-model="images" label="Upload Student Images" multiple prepend-icon="mdi-image" accept="image/*"
          outlined dense @change="handleFileUpload"  hide-details  class="file-input-no-details" /> -->
        <v-file-input v-model="images" label="Upload Student Images" multiple prepend-icon="mdi-image" accept="image/*" outlined dense @change="handleFileUpload" hide-details class="file-input-no-details">
          <template v-slot:selection="{ files }">
            <div v-if="files && files.length === 0">
              <span>Select Images</span>
            </div>
          </template>
        </v-file-input>

      </v-col>
    </v-row>

    <!-- Action Buttons -->
    <v-row v-if="studentList.length" class="mt-4">
      <v-col cols="12" md="4">
        <v-btn color="primary" block :disabled="!hasAssignments" @click="uploadImages">
          Upload {{ assignedCount }} Images
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn color="error" block :disabled="!hasAssignments" @click="clearAssignments">
          Clear All
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <!-- Student Cards Section (Scrollable) -->
      <v-col v-if="studentList.length" cols="12" md="8" class="student-section">
        <v-card class=" pa-4" elevation="4" rounded>
          <!-- Close Icon in Top Right -->

          <v-card-title class="headline">Students</v-card-title>
          <v-card-text>
            <v-row v-if="studentList.length" class="drop-zone" @drop="onStudentDrop($event, 'students')"
              @dragover.prevent @dragenter.prevent>
              <v-col v-for="student in studentList" :key="student.id" cols="12" md="4" sm="4" class="student-card"
                @drop="onStudentDrop($event, student)" @dragover.prevent @dragenter.prevent>
                <v-card class="ma-2" elevation="2" outlined hover
                  :class="{ 'bordered-card': student._assignedImage, 'shadow-card': student._assignedImage }">
                  <!-- <v-btn
        icon
        small
        class="close-btn"
        @click="closeCard"
        style="position: absolute; top: 8px; right: 8px; z-index: 1"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn> -->

                  <v-btn v-if="student._assignedImage" density="compact" icon="mdi-close"
                    @click="removeAssignment(student)"
                    style="position: absolute; top: 8px; right: 8px; z-index: 1"></v-btn>
                  <v-img :src="student._assignedImage  ? student._assignedImage.url: student.image  || noImage " aspect-ratio="1" contain height="auto"  width="250px">
                    <!-- <template v-slot:placeholder>
                      <v-icon size="64">mdi-account</v-icon>
                    </template> -->
                  </v-img>
                  <v-card-title>
                    {{ student.roll_symbol_no }} - {{ student.name }}
                    <v-chip v-if="student._assignedImage" color="success" small class="ml-2">
                      Assigned
                    </v-chip>
                  </v-card-title>
                  <!-- <v-card-actions v-if="student._assignedImage">
                    <v-btn color="error" small @click="removeAssignment(student)">
                      Remove
                    </v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-col>
            </v-row>
            <v-alert v-else type="info">
              No students found for selected class
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Sticky Image Pool (Right Side) -->
      <v-col v-if="uploadedImages.length" cols="12" md="4" class="sticky-section">
        <v-card class="pa-4" elevation="4" rounded>
          <v-card-title class="headline">Uploaded Images</v-card-title>
          <v-card-text>
            <div v-if="uploadedImages.length" class="drag-zone">
              <v-row>
                <v-col v-for="(image, index) in uploadedImages" :key="index" cols="6" sm="6" md="6">
                  <v-card draggable="true" @dragstart="onDragStart($event, image)" class="image-card ma-2" outlined>
                    <v-img :src="image.url || noImage" aspect-ratio="1" cover />
                    <v-card-subtitle class="text-truncate">
                      {{ image.name }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <v-alert v-else type="info">
              No images uploaded yet
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>



    <!-- Instructions Dialog -->
    <v-dialog v-model="showDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">How to Match Images</v-card-title>
        <v-card-text>
          <ol class="mb-4">
            <li>Select a class from the dropdown</li>
            <li>Upload student images using the file input</li>
            <li>Drag images from the right panel onto student cards on the left</li>
            <li>Click "Upload Images" when finished</li>
          </ol>
          <v-alert type="info">
            You can remove assignments by clicking the "Remove" button on student cards
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>




<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useClassStore } from '@/Store/className.js'
import { apiConfig } from '@/config/apiConfig'
import Swal from "sweetalert2";
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"

const classStore = useClassStore()
const userType = ref('')
const userTypes = ['Student', 'Employee']
const selectedClass = ref('')
const studentList = ref([])
const images = ref([])
const showDialog = ref(false)
const uploadedImages = ref([])
const draggedImage = ref(null)
const assignedCount = computed(() => studentList.value.filter(s => s._assignedImage).length)
const hasAssignments = computed(() => assignedCount.value > 0)

// const getImage = (img) => {
//   return img ? `${apiConfig.imageUrl}/${img}` : banner1
// }

// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;

const fetchStudents = async (id) => {
  if (!id) return
  try {
    studentList.value = await classStore.fetchStudentsByClassId(id)
    studentList.value.forEach(student => {
      student._assignedImage = null
    })
  } catch (err) {
    console.error('Error fetching students:', err)
  }
}

const handleFileUpload = () => {
  uploadedImages.value = images.value.map(file => ({
    file,
    name: file.name,
    url: URL.createObjectURL(file)
  }))
}

const onDragStart = (event, image) => {
  draggedImage.value = image
  event.dataTransfer.setData('text/plain', image.name)
}

const onStudentDrop = (event, student) => {
  event.preventDefault()
  if (draggedImage.value) {
    // Remove from any existing assignment
    studentList.value.forEach(s => {
      if (s._assignedImage?.name === draggedImage.value.name) {
        s._assignedImage = null
      }
    })
    student._assignedImage = draggedImage.value
    draggedImage.value = null
    const data = event.dataTransfer.getData('text/plain');
    // console.log('Dropped data:', data);
  }
}


const removeAssignment = (student) => {
  student._assignedImage = null
}

const clearAssignments = () => {
  studentList.value.forEach(student => {
    student._assignedImage = null
  })
}

const uploadImages = async () => {
  const formData = new FormData();
  const dataPayload = [];
  studentList.value.forEach((student, index) => {
    const image = student._assignedImage?.file;
    if (image instanceof File) {
      const customName = student._assignedImage.customName || image.name;
      const fileField = `file`;
      formData.append(fileField, image);
      dataPayload.push({
        id: student.id,
        imageName: image.name,
      });
    }
  });
  if (!dataPayload.length) {
    throw new Error('No valid image assignments to upload');
  }
  formData.append('data', JSON.stringify(dataPayload));
  try {
    const accessToken = localStorage.getItem("accessToken");
    // console.log('Form data:', formData);
    const response = await fetch(`${apiConfig.baseUrl}/student/`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
      body: formData
    });


    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Upload failed');
    }
    const result = await response.json();
    // console.log('Server response:', result);

    Swal.fire({
      icon: "success",
      title: "Bulk image upload successfully",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });


    setTimeout(() => {
      selectedClass.value = []
      studentList.value = [];
      // console.log('Student list:', studentList.value);
      userType.value = null;
      images.value = [];
      uploadedImages.value = [];
      draggedImage.value = null;
    }, 1000);

    return result;
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

onMounted(async () => {
  try {
    await classStore.fetchClassInfoList()
  } catch (err) {
    console.error('Error fetching class list:', err)
  }
})
</script>

<style scoped>
.file-input-no-details .v-input__control .v-input__slot .v-file-input__input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: red;
}

.file-input-no-details .v-input__control .v-input__slot .v-file-input__input input {
  visibility: hidden;
}

.bordered-card {
  border: 3px solid #4caf50;
}

.shadow-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.drop-zone {
  min-height: 300px;
  border: 2px dashed #eee;
  border-radius: 4px;
  padding: 16px;
}

.drag-zone {
  min-height: 300px;
}

.student-card {
  cursor: pointer;
  transition: all 0.3s;
}

.student-card:hover {
  transform: translateY(-2px);
}

.image-card {
  cursor: grab;
  transition: all 0.2s;
}

.image-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.image-card:active {
  cursor: grabbing;
}


.student-section {
  max-height: 70vh;
  overflow-y: auto;
}

.sticky-section {
  position: sticky;
  top: 0;
  height: 70vh;
  overflow-y: auto;
  padding-top: 20px;
}

.student-card {
  transition: transform 0.3s ease;
}

.student-card:hover {
  transform: translateY(-5px);
}
</style>